import {
  HOMEPAGE,
  SCHEME_DETAILS,
  SCHEME_CUSTOM_DETAILS,
  WORKBENCH_MYDESIGN_SCHEMEDETAIL_3D,
  WORKBENCH_MYDESIGN_SCHEMEDETAIL_CUSTOMIZE,
  DESIGNER_HOMEPAGE_SCHEME_DETAILS,
  DESIGNER_HOMEPAGE_SCHEME_CUSTOM_DETAILS,
  SCHEME_MEITU_DETAILS,
  SCHEME_COLUMN_DETAILS,
  SCHEME_PANORAMIC,
  COURSE_DETAILS_FREE,
  COURSE_COLUMN_DETAILS,
  COURSE_INDUSTRYENCYCLOPEDIA_DETAILS,
  COURSE_LIVE_DETAILS_STATION_FREE,
  COURSE_GRAPHICTUTORIAL_DETAILS,
  MATERIAL_SINGLEMODEL_DETAILS,
  MATERIAL_COMBINEDMODEL_DETAILS,
  MATERIAL_SCENEMODEL_DETAILS,
  MATERIAL_COLUMNMODEL_DETAILS,
  PERSONALCENTER_HELP_QUESTION_DETAIL,
  PERSONALCENTER_HELP_FEEDBACK_DETAIL,
  // PERSONALCENTER_SETTINGS_ABOUT,
  DESIGNER_HOMEPAGEOFOTHERS,
  COMMUNITY_POSTDETAILS,
  SERVICE_DETAILS,
  HOMEPAGE_NEWUSER,
  HOMEPAGE_NEWUSER__OUTSIDE,
  PERSONALCENTER_INVITE,
  PERSONALCENTER_INVITE_OUTSITE,
  PERSONALCENTER_INVITE_PAST,
  PERSONALCENTER_INVITE_PAST_DETAILS,
  PERSONALCENTER_POINTSMARKET_LOTTERY,
  PERSONALCENTER_POINTSMARKET_RULES,
  WORKBENCH_DATAANALYSIS,
  COMMUNITY,
  COMMUNITY_TOPICDETAILS,
  COMMUNITY_ARTICLE_DETAILS,
  UNIT,
  UNIT_DETAILS,
  COURSE_TRAINING_DETAILS,
  COURSE_TRAINING_ADDRESS,
  COURSE_TRAINING_APPLY,
  COURSE_TRAINING,
  PERSONALCENTER_MYCOURSE,
  ACTIVITY_SEVENDAY_FREE,
  WORKBENCH_MARKETING_MAGICPEN_DETAIL,
  COUPONCENTER,
} from '@/utils/consts/app-page';

/**
 * 注意：将路由和app字典一一对应，如果路由改变，则本页面必须同步改！！！
 */
export const pageDictionary = {
  // 方案_3D方案详情
  'Scheme.Details': {
    name: SCHEME_DETAILS,
    params({ params }) {
      const { id: schemeId } = params;
      return {
        schemeId,
      };
    },
  },
  // 方案_自定义方案详情
  'Scheme.Custom.Details': {
    name: SCHEME_CUSTOM_DETAILS,
    params({ params }) {
      const { id: schemeId } = params;
      return {
        schemeId,
      };
    },
  },
  // 我的设计_方案详情_3D方案
  'Origin.Scheme.Details': {
    name: WORKBENCH_MYDESIGN_SCHEMEDETAIL_3D,
    params({ params }) {
      const { id: schemeId } = params;
      return {
        schemeId,
      };
    },
  },
  // 我的设计_方案详情_自定义方案
  'Origin.Scheme.Custom.Details': {
    name: WORKBENCH_MYDESIGN_SCHEMEDETAIL_CUSTOMIZE,
    params({ params }) {
      const { id: schemeId } = params;
      return {
        schemeId,
      };
    },
  },
  // 设计师主页_3D方案详情
  'Designer.Scheme.Details': {
    name: DESIGNER_HOMEPAGE_SCHEME_DETAILS,
    params({ params }) {
      const { id: schemeId } = params;
      return {
        schemeId,
      };
    },
  },
  // 设计师主页_自定义方案详情
  'Designer.Scheme.Custom.Details': {
    name: DESIGNER_HOMEPAGE_SCHEME_CUSTOM_DETAILS,
    params({ params }) {
      const { id: schemeId } = params;
      return {
        schemeId,
      };
    },
  },
  // 美图详情页
  'Scheme.MeiTu.Details': {
    name: SCHEME_MEITU_DETAILS,
    params({ params }) {
      const { id: effectId } = params;
      return {
        effectId,
      };
    },
  },
  // 方案专栏详情页
  'Scheme.Column.Details': {
    name: SCHEME_COLUMN_DETAILS,
    params({ params }) {
      const { id: columnId } = params;
      return {
        columnId,
      };
    },
  },
  'Scheme.Panorama': {
    name: SCHEME_PANORAMIC,
    params({ params, query }) {
      return {
        id: params.id,
        ...query,
      };
    },
  },
  // 课程详情
  'Course.Details': {
    name: COURSE_DETAILS_FREE,
    params({ params }) {
      const { id: courseId } = params;
      return {
        courseId,
      };
    },
  },
  // 课程专栏详情
  'Course.Column.Details': {
    name: COURSE_COLUMN_DETAILS,
    params({ params }) {
      const { id: columnId } = params;
      return {
        columnId,
      };
    },
  },
  // 免费直播回看_站内
  'Course.Live.Details': {
    name: COURSE_LIVE_DETAILS_STATION_FREE,
    params({ params }) {
      const { id: liveId } = params;
      return {
        liveId,
      };
    },
  },
  // 行业百科详情
  'Course.Baike.Details': {
    name: COURSE_INDUSTRYENCYCLOPEDIA_DETAILS,
    params({ params, query }) {
      const { id: industryEncyclopediaId } = params;
      return {
        industryEncyclopediaId,
        ...query,
      };
    },
  },
  // 图文教程详情
  'Course.GraphicTutorial.Details': {
    name: COURSE_GRAPHICTUTORIAL_DETAILS,
    params({ params, query }) {
      const { id: graphicTutorialId } = params;
      return {
        graphicTutorialId,
        ...query,
      };
    },
  },
  // 单体模型详情
  'Material.SingleModel.Details': {
    name: MATERIAL_SINGLEMODEL_DETAILS,
    params({ params }) {
      const { id: modelId } = params;
      return {
        modelId,
      };
    },
  },
  // 组合模型详情
  'Material.CombinedModel.Details': {
    name: MATERIAL_COMBINEDMODEL_DETAILS,
    params({ params }) {
      const { id: combinedId } = params;
      return {
        combinedId,
      };
    },
  },
  // 场景模型详情
  'Material.SceneModel.Details': {
    name: MATERIAL_SCENEMODEL_DETAILS,
    params({ params }) {
      const { id: sceneId } = params;
      return {
        sceneId,
      };
    },
  },
  // 模型专栏详情
  'Material.Column.Details': {
    name: MATERIAL_COLUMNMODEL_DETAILS,
    params({ params }) {
      const { id: columnId } = params;
      return {
        columnId,
      };
    },
  },
  // 设计师主页
  'Designer.HomePage': {
    name: DESIGNER_HOMEPAGEOFOTHERS,
    params({ params }) {
      const { id: homepageId } = params;
      return {
        homepageId,
      };
    },
  },
  // 服务详情
  'Service.Market.Details': {
    name: SERVICE_DETAILS,
    params({ params, query }) {
      const { id: serviceId } = params;
      return {
        serviceId,
        ...query,
      };
    },
  },
  // 社区_帖子详情页 常规动态详情
  'Community.Post.Details': {
    name: COMMUNITY_POSTDETAILS,
    params({ params }) {
      const { id: postId } = params;
      return {
        postId,
      };
    },
  },
  // 社区_话题详情页
  'Community.Topic.Details': {
    name: COMMUNITY_TOPICDETAILS,
    params({ params }) {
      const { id: topicId } = params;
      return {
        topicId: Number(topicId),
      };
    },
  },
  // 社区_首页
  'Community.Index': {
    name: COMMUNITY,
    params({ params }) {
      const { id: categoryId } = params;
      return {
        categoryId,
      };
    },
  },
  // 帮助与反馈_常见问题
  'Help.Question.Details': {
    name: PERSONALCENTER_HELP_QUESTION_DETAIL,
    params({ params }) {
      const { id: questionId } = params;
      return {
        questionId,
      };
    },
  },
  // 意见反馈_反馈详情
  'Help.Feedback.Details': {
    name: PERSONALCENTER_HELP_FEEDBACK_DETAIL,
    params({ params }) {
      const { id: feedbackId } = params;
      return {
        feedbackId,
      };
    },
  },
  // 新用户礼包__端内
  'Activity.App.Gift': {
    name: HOMEPAGE_NEWUSER,
    params({ query }) {
      return {
        ...query,
      };
    },
  },
  // 邀请活动__端内
  'Activity.App.Invite': {
    name: PERSONALCENTER_INVITE,
    params({ query }) {
      return {
        ...query,
      };
    },
  },
  // 新用户礼包__端外
  'Activity.Gift': {
    name: HOMEPAGE_NEWUSER__OUTSIDE,
    params({ query }) {
      return {
        ...query,
      };
    },
  },
  // 邀请活动__端外
  'Activity.Gift.Invite': {
    name: PERSONALCENTER_INVITE_OUTSITE,
    params({ query }) {
      return {
        ...query,
      };
    },
  },
  // 往期邀请活动详情
  'Activity.App.Invite.Past': {
    name: PERSONALCENTER_INVITE_PAST,
    params({ query }) {
      return {
        ...query,
      };
    },
  },
  // 往期邀请活动列表
  'Activity.App.Invite.Past.List': {
    name: PERSONALCENTER_INVITE_PAST_DETAILS,
    params({ query }) {
      return {
        ...query,
      };
    },
  },
  // // 关于三维家设计师
  // About: {
  //   name: PERSONALCENTER_SETTINGS_ABOUT,
  // },
  // // 用户服务协议
  // 'Registration.Agreement': {
  //   name: PERSONALCENTER_SETTINGS_ABOUT,
  // },
  // // 隐私政策
  // 'Privacy.Policy': {
  //   name: PERSONALCENTER_SETTINGS_ABOUT,
  // },
  // 积分抽奖
  'Score.Market.Draw': {
    name: PERSONALCENTER_POINTSMARKET_LOTTERY,
    params({ query }) {
      return {
        ...query,
      };
    },
  },
  // 积分规则
  'Score.Market.Rules': {
    name: PERSONALCENTER_POINTSMARKET_RULES,
    params({ query }) {
      return {
        ...query,
      };
    },
  },
  // 数据分析
  'Workbench.DataAnalysis': {
    name: WORKBENCH_DATAANALYSIS,
    params({ query }) {
      return {
        ...query,
      };
    },
  },
  // 1.9.0
  // 社区_文章动态详情
  'Community.Article.Details': {
    name: COMMUNITY_ARTICLE_DETAILS,
    params({ params }) {
      const { id: postId } = params;
      return {
        postId,
      };
    },
  },
  // 同户型功能介绍页跳app的找户型首页
  'Activity.V2.Introduce': {
    name: UNIT,
    params({ query }) {
      return {
        ...query,
      };
    },
  },
  // 户型详情
  'Door.Model.Details': {
    name: UNIT_DETAILS,
    params({ params }) {
      const { id: unitId } = params;
      return {
        unitId,
      };
    },
  },
  // 培训详情
  'Train.Details': {
    name: COURSE_TRAINING_DETAILS,
    params({ params }) {
      const { id: trainId } = params;
      return {
        trainId,
      };
    },
  },
  // 培训搜索结果页
  'Train.List': {
    name: COURSE_TRAINING,
    params({ query }) {
      return {
        ...query,
      };
    },
  },
  // 培训搜索结果页
  'Train.List.Mine': {
    name: PERSONALCENTER_MYCOURSE,
    params({ query }) {
      return {
        ...query,
        type: 3, // 跳到app我的课程-我的培训tab
      };
    },
  },
  // 培训地图
  'Train.Map': {
    name: COURSE_TRAINING_ADDRESS,
    params({ query }) {
      return {
        ...query,
      };
    },
  },
  // 培训订单
  'Train.Order': {
    name: COURSE_TRAINING_APPLY,
    params({ query }) {
      return {
        ...query,
      };
    },
  },
  // 课程二维码跳app的培训详情页
  'Train.QRCode': {
    name: COURSE_TRAINING_DETAILS,
    params({ params }) {
      const { id: trainId } = params;
      return {
        trainId,
      };
    },
  },
  // 7天免费试用
  'Free.Trail': {
    name: ACTIVITY_SEVENDAY_FREE,
    params({ query }) {
      return {
        ...query,
      };
    },
  },
  // 神笔视频详情页面
  'Magic.Pen.Details': {
    name: WORKBENCH_MARKETING_MAGICPEN_DETAIL,
    params({ params, query }) {
      const { id: videoId } = params;
      return {
        videoId,
        ...query,
      };
    },
  },
  // 2.1.0新增-领券中心
  'Activity.Coupon.Center': {
    name: COUPONCENTER,
    params({ query }) {
      return {
        ...query,
      };
    },
  },
  // 免费报价
  'Quote.Free': {
    name: HOMEPAGE,
    params({ query }) {
      return {
        ...query,
      };
    },
  },
  // 报价清单
  'Quote.Result': {
    name: HOMEPAGE,
    params({ query }) {
      return {
        ...query,
      };
    },
  },
};

/**
 * 提供页面埋点的参数
 * @param {object} param 路由参数
 */
export const getPageViewParams = ({
  name, query, params, meta = {},
} = {}) => {
  const pageDictItem = pageDictionary[name];
  if (!pageDictItem) return {};

  const { title = '' } = meta;
  let formatParams = pageDictItem.params;
  if (typeof formatParams === 'function') {
    formatParams = formatParams({ query, params });
  }
  return JSON.stringify({ ...formatParams, name: pageDictItem.name, title });
};

/**
 * 提供页面跳转app的参数
 * @param {*} param0 路由参数
 */
export const getNavigatorToParams = ({
  name, query = {}, params = {}, meta = {},
} = {}) => {
  const pageDictItem = pageDictionary[name];
  if (!pageDictItem) return {};

  let formatParams = pageDictItem.params;
  if (typeof formatParams === 'function') {
    formatParams = formatParams({ query, params });
  }
  const result = {
    name: pageDictItem.name,
    params: formatParams,
  };
  const options = {
    promotion_name: meta.title || '',
  };
  if (meta && meta.tags) {
    options.tags = meta.tags;
  }
  /**
   * linkMe的参数
   * result:跳转到详情页面的所需参数
   * promotion_name: 自定义深度链接名称
   * tags: 自定义深度链接标签名称，多个名称用逗号分隔
   */
  return { result, options };
};
